export const EMAIL_FOR_AUTH = "emailForSignIn";

export const AUTH_TARGET_ROUTE = "authTargetRoute";
export const AUTH_ERROR_MESSAGE = "authErrorMessage";
export const GUEST_PROJECT_TEMPORARY = "guestProjectTemporary";
